export enum StripeStatusEnums {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_EXPIRED = 'INCOMPLETE_EXPIRED',
  PAST_DUE = 'PAST_DUE',
  TRIALING = 'TRIALING',
  UNPAID = 'UNPAID',
  // Not Stripe's: the paywall row of a hardware_first order that has closed won but not shipped.
  // No Stripe subscription stands behind it yet, so there is nothing to check out or upgrade.
  PENDING_SHIPMENT = 'PENDING_SHIPMENT'
}

export enum PlanEnums {
  LEGACY_TRIAL_PLAN = 'LEGACY_TRIAL_PLAN',
  PREMIUM_PLAN = 'PREMIUM_PLAN',
  CIRRUS_WINDOWS_PLAN = 'CIRRUS_WINDOWS_PLAN',
  CIRRUS_HARDWARE_PLAN = 'CIRRUS_HARDWARE_PLAN',
  PRO_PLAN = 'PRO_PLAN',
  CIRRUS_HARDWARE_PRO_PLAN = 'CIRRUS_HARDWARE_PRO_PLAN',
  CIRRUS_WINDOWS_PRO_PLAN = 'CIRRUS_WINDOWS_PRO_PLAN',
  CELLULAR_PLAN = 'CELLULAR_PLAN',
  ANALYTICS_PLAN = 'ANALYTICS_PLAN',
  WHITELABEL_PRO_PLAN = 'WHITELABEL_PRO_PLAN',
  SMB_PRO_PLAN = 'SMB_PRO_PLAN'
}

export enum BillingCycle {
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export enum SubscriptionCategoryEnums {
  DISPLAY = 'DISPLAY',
  CELLULAR = 'CELLULAR',
  ANALYTICS = 'ANALYTICS'
}
